import { RootState } from "index";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  Row,
  Label,
  Card,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  CardBody,
  TabContent,
  TabPane,
} from "reactstrap";
import { customStyle } from "shared/CommonCSS";
import { getCurrentReportFilesAction, setVesselID } from "Store/Generic/ReportingSlice";
import classnames from "classnames";
import { VesselTypeConstant } from "shared/constants";
import PendingLNGCargoDetails from "./tabs/PendingLNGCargoDetails";
import CIIPendingFiles from "./tabs/CIIPendingFiles";
import PendingBDNFiles from "./tabs/PendingBDNFiles";
import { PendingEDNFiles } from "./tabs/PendingEDNFiles";
import PendingSpOpLogBook from "./tabs/PendingSpOpLogBook";
import PendingCargoDocs from "./tabs/PendingCargoDocs";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import { Get } from "VesselMaster/vesselMaster.hooks";
import ErrorComponent from "Components/ErrorComponent";
import { Skeleton } from "@mui/material";
import PendingBlAttachment from "./tabs/PendingBlAttachment";
import env from "environment_system/env_system";
const Pending = () => {
  /** State variables start */
  const dispatch = useDispatch();
  const { Vessels, VesselID, onboardedVessels, ReportID } = useSelector(
    (state: RootState) => state.Reporting
  );
  const [activeAdjustmentsTab, setActiveAdjustmentsTab] = useState("1");
  const vessel = Vessels.find((rec: any) => rec.id === VesselID);

  const handleVesselSelectionChanges = (e: any) => {
    dispatch(setVesselID(e.id));

    const selectedVessel = Vessels.find((v: any) => v.id === e.id);
    if (!selectedVessel) return;

    let defaultTab = activeAdjustmentsTab;
    if (defaultTab === "2" && selectedVessel?.vessel_type_precedence_id !== VesselTypeConstant.LNG_CARRIER) {
      defaultTab = "1";
    }
    if (defaultTab === "5" && selectedVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER && selectedVessel?.vessel_type_precedence_id !== VesselTypeConstant.GENERAL_CARGO_SHIP) {
      defaultTab = "6";
    }
    if (defaultTab === "6" && (selectedVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || selectedVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP)) {
      defaultTab = "5";
    }
    setActiveAdjustmentsTab(defaultTab);
  };


  /** Change tabs */
  const toggle = (tab: any) => {
    if (activeAdjustmentsTab !== tab) {
      setActiveAdjustmentsTab(tab);
    }
  };

  /** Vessel's other setting;s object used for edit */
  const { data: OtherSettings, isLoading: OtherSettingsLoading, isError: OtherSettingsError }:
    { data: any, isLoading: any, isError: any } = useQuery(
      [queryKeyes.vessel.VesselOtherSettingsObject.key, VesselID],
      async () => {
        return await Get(queryKeyes.vessel.VesselOtherSettingsObject.url(VesselID), VesselID);
      },
      {
        enabled: true,
        staleTime: Infinity,
      }
    );
  return (
    <React.Fragment>
      <Card className="p-1 card-custom height-20">
        <CardHeader className="p-2 d-flex justify-content-between align-items-center">
          <h4
            style={{ display: "inline" }}
            key="dashboard"
            className="page_title ps-0 mb-0"
          >
            Pending Files
          </h4>
          <div className="d-flex align-items-center" style={{ minWidth: "300px" }}>
            <Label className="mb-0 me-2">Select vessel</Label>
            <div className="flex-grow-1">
              <Select
                options={!env?.offlineCopy ? onboardedVessels?.filter((item: any) => !item.is_vessel_offline) as any[] : onboardedVessels}
                getOptionLabel={(option: any) => option?.vessel_name_type_name}
                getOptionValue={(option: any) => option.id}
                onChange={async (e: any) => {
                  handleVesselSelectionChanges(e)
                  await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
                }}
                menuPortalTarget={document.body}
                styles={customStyle}
                defaultValue={
                  VesselID && vessel?.vessel_name
                    ? {
                      id: VesselID,
                      vessel_name_type_name: vessel.vessel_name_type_name,
                    }
                    : null
                }
                isOptionDisabled={(option: any) => option.is_under_maintenance}
              />
            </div>
          </div>
        </CardHeader>
        <Row>
          {OtherSettingsLoading && (
            <CardBody className="p-0">
              <Row className="mb-1 px-2">
                <Card className="p-0 border-0">
                  <CardHeader className="pb-0">
                    <Nav tabs className="border-0">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <NavItem key={i} className="me-2">
                          <Skeleton variant="rounded" width={100} height={28} />
                        </NavItem>
                      ))}
                    </Nav>
                  </CardHeader>

                  <CardBody className="p-0">
                    <TabContent className="text-muted p-2">
                      <TabPane>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <Skeleton
                            key={i}
                            variant="rounded"
                            height={32}
                            sx={{ bgcolor: "grey.300", mb: 1 }}
                          />
                        ))}
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Row>
            </CardBody>
          )}
          {OtherSettingsError && <ErrorComponent message='Unable to load required data!' />}
        </Row>
        {!(OtherSettingsLoading || OtherSettingsError) && (
          <CardBody className="p-0">
            <Row className="mb-1 px-2">
              <Card className="p-0 border-0 ">
                <CardHeader className="pb-0">
                  <Nav tabs className="border-0">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeAdjustmentsTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        BDN Files
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeAdjustmentsTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        EDN Files
                      </NavLink>
                    </NavItem>
                    {
                      Vessels.filter(
                        (item: any) =>
                          item.id === VesselID &&
                          (item.vessel_type_precedence_id === VesselTypeConstant.CONTAINER ||
                            item.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
                          item.display === true &&
                          OtherSettings && OtherSettings[0]?.reefer_container_available === true
                      ).length > 0 && (
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeAdjustmentsTab === "3",
                            })}
                            onClick={() => {
                              toggle("3");
                            }}
                          >
                            Cargo Docs
                          </NavLink>
                        </NavItem>
                      )}
                    {
                      Vessels.some(
                        (item: any) =>
                          item.id === VesselID &&
                          item.display === true &&
                          (item.vessel_type_precedence_id === VesselTypeConstant.TANKER ||
                            item.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER ||
                            item.vessel_type_precedence_id === VesselTypeConstant.GAS_CARRIER
                          )
                      ) && (
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeAdjustmentsTab === "4",
                            })}
                            onClick={() => toggle("4")}
                          >
                            Log Book Files
                          </NavLink>
                        </NavItem>
                      )}
                    {
                      Vessels.filter(
                        (item: any) =>
                          item.id === VesselID &&
                          item.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER &&
                          item.display === true
                      ).length > 0 && (
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeAdjustmentsTab === "5",
                            })}
                            onClick={() => {
                              toggle("5");
                            }}
                          >
                            N<sub>2</sub> Adjustments Files
                          </NavLink>
                        </NavItem>
                      )}
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeAdjustmentsTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        CII Adjustment Files
                      </NavLink>
                    </NavItem>
                    {
                      Vessels.filter(
                        (item: any) =>
                          item.id === VesselID &&
                          (item.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER)
                      ).length > 0 && (
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeAdjustmentsTab === "7",
                            })}
                            onClick={() => {
                              toggle("7");
                            }}
                          >
                            BL Attachment
                          </NavLink>
                        </NavItem>
                      )}
                  </Nav>
                </CardHeader>
                <CardBody className="p-0">
                  <TabContent
                    activeTab={activeAdjustmentsTab}
                    className="text-muted p-0"
                  >
                    <TabPane tabId='1' className="mx-0">
                      <PendingBDNFiles />
                    </TabPane>
                    <TabPane tabId='2' className="mx-0">
                      <PendingEDNFiles />
                    </TabPane>
                    <TabPane tabId='3' className="mx-0">
                      <PendingCargoDocs />
                    </TabPane>
                    <TabPane tabId='4' className="mx-0">
                      <PendingSpOpLogBook />
                    </TabPane>
                    <TabPane tabId="5" className="mx-0">
                      <PendingLNGCargoDetails />
                    </TabPane>
                    <TabPane tabId="6" className="mx-0">
                      <CIIPendingFiles />
                    </TabPane>
                    <TabPane tabId="7" className="mx-0">
                      <PendingBlAttachment />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Row>
          </CardBody>
        )}
      </Card>
    </React.Fragment>
  );
};

export default Pending;
